<template>
  <div class="relative">
    <b-table
      :items="fetcher.data"
      :fields="fields"
      responsive
      sticky-header
      show-empty
      class="!max-h-[68vh] !mb-0"
      :empty-text="fetcher.isLoading ? '' : 'Silahkan tambahkan bahan packing agar data dapat ditampilkan di sini.'"
      @scroll.native="handleScroll"
    >
      <template #cell(name)="row">
        <div class="flex items-center gap-2">
          <img
            :src="row.item.image_url"
            :alt="row.item.name"
            width="40"
            height="40"
            class="rounded object-cover"
            lazy
            @error="handleImageError($event)"
          >
          <span>{{ row.value }}</span>
        </div>
      </template>
      <template #cell(price)="row">
        {{ row.item.price | rupiah }} {{ row.item.charge_type ? `per ${parseChargeType(row.item.charge_type)}` : '' }}
      </template>
      <template #cell(id)="row">
        <div class="flex items-center justify-start gap-2">
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#828282]/10 rounded-full"
            @click="handleEdit(row.item)"
          >
            <span class="k-edit text-[24px] text-[#828282]" />
          </button>
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#F95031]/10 rounded-full"
            @click="handleDelete(row.item)"
          >
            <span class="k-trash text-[24px] text-[#F95031]" />
          </button>
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#08A0F7]/10 rounded-full"
            @click="handleViewDetail(row.item)"
          >
            <span class="k-eye text-[24px] text-[#08A0F7]" />
          </button>
        </div>
      </template>
    </b-table>
    <div
      v-if="fetcher.isLoading"
      class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
    >
      <div class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span class="text-sm text-gray-600">Memuat data...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { toastError } from '@/libs/toastification'
import { BahanPackingConfirmedFields, ChargeType } from '../config'

export default {
  name: 'BahanPackingConfirmed',
  data() {
    return {
      fetcher: null,
      items: [],
      fields: BahanPackingConfirmedFields,
    }
  },
  created() {
    this.initializeFetcher()
  },
  mounted() {
    this.refreshData()
  },
  methods: {
    initializeFetcher() {
      const fnFetch = ({
        offset, limit,
      }) => this.$http_new.get('/komship/api/v1/packing-materials', {
        params: {
          offset,
          limit,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => {
        toastError('Gagal mengambil data bahan packing, silahkan coba lagi')
        return {
          data: [],
        }
      })

      this.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
    },
    refreshData() {
      this.fetcher.fetchData({ reset: true })
    },
    handleScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight + 500 >= event.target.scrollHeight) {
        if (this.fetcher.data.length <= 0) return
        this.fetcher.fetchData()
      }
    },
    handleImageError(event) {
      const { target } = event
      if (target.dataset.fallback) {
        target.style.display = 'none'
        return
      }
      target.dataset.fallback = 'true'
      target.src = 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
    },
    handleEdit(item) {
      this.$emit('request-edit', { item, status: 'konfirmasi' })
    },
    handleDelete(item) {
      this.$emit('request-delete', { item, status: 'konfirmasi' })
    },
    handleViewDetail(item) {
      this.$emit('request-view-detail', { item, status: 'konfirmasi' })
    },
    parseChargeType(value) {
      return ChargeType[value]
    },
  },
}
</script>
